<ng-container *ngIf="(currentUrl | async) === '/home'">
  <div class="old-chat-margin">
    <postgenie-home></postgenie-home>
  </div>
</ng-container>
<ng-container *ngIf="(currentUrl | async) === '/profile'">
  <div class="old-chat-margin">
    <postgenie-app-profile [user]="user()"></postgenie-app-profile>
  </div>
</ng-container>
<ng-container *ngIf="(currentUrl | async) === '/post'">
  <postgenie-result-process [user]="user()"></postgenie-result-process>
</ng-container>
